export const goalSkillEnums = {
    SKILL: 'SKILL',
    BEHAVIOR: 'BEHAVIOR',
    PARENT_TRAINING: 'PARENT_TRAINING',
};
